import upperFirst from 'lodash/upperFirst';
import alt from 'components/Dispatcher';
import {Map} from 'immutable';
import {Store, StoreMethods} from '@store/@types/alt';
import {
  AxisState,
  Metric,
  MetricAxis,
  MetricData,
  MetricFilter,
  MetricParams,
  MetricResponse,
} from '@store/@types/metric';
import MetricsTrendsActions, {MetricsTrendsActionsInterface} from './NineBoxMetricActions';
import {FetchMetricReq} from '@store/metrics-trends/NineBoxMetricSource';

export const DEFAULT_HORIZONTAL_METRIC = Metric.AGGREGATED_SKILL as const;
export const DEFAULT_VERTICAL_METRIC = Metric.ENGAGEMENT as const;

export interface MetricsStoreState {
  horizontal: AxisState;
  vertical: AxisState;
  // TODO rewrite these to top level fields
  time: {
    meeting: MetricData;
    review: MetricData;
  };
  loading: {
    metricHorizontal: boolean;
    metricVertical: boolean;
    time: boolean;
  };
  exportSelections: Map<MetricParams, boolean>;
}

/**
 * Handles Axis state and sidebar information
 */
class NineBoxMetricStore
  extends Store<MetricsStoreState>
  implements StoreMethods<MetricsTrendsActionsInterface>
{
  constructor() {
    super();
    this.state = {
      horizontal: {
        metric: new MetricParams({
          metric: DEFAULT_HORIZONTAL_METRIC,
        }),
        data: {},
      },
      vertical: {
        metric: new MetricParams({
          metric: DEFAULT_VERTICAL_METRIC,
        }),
        data: {},
      },
      time: {
        meeting: {},
        review: {},
      },
      loading: {
        metricHorizontal: false,
        metricVertical: false,
        time: false,
      },
      exportSelections: Map(),
    };
    this.bindActions(MetricsTrendsActions);
  }

  toggleExport([params, checked]: [MetricParams, boolean]): void {
    this.setState({
      exportSelections: this.state.exportSelections.set(params, checked),
    });
  }

  setAxisMetric({
    metricAxis,
    metricParams,
  }: {
    metricAxis: MetricAxis;
    metricParams: MetricParams;
  }): void {
    this.setState({
      [metricAxis]: {
        metric: metricParams,
        data: {},
      },
      loading: {
        ...this.state.loading,
        [`metric` + upperFirst(metricAxis)]: true,
      },
    });
  }

  fetchMetric(req: FetchMetricReq): void {
    this.setState({
      loading: {
        ...this.state.loading,
        [`metric` + upperFirst(req.metricAxis)]: true,
      },
    });
  }
  fetchMetricError(error: Error): void {}
  fetchMetricSuccess({data, metricAxis}: MetricResponse): void {
    this.setState({
      [metricAxis]: {
        metric: this.state[metricAxis].metric,
        data,
      },
      loading: {
        ...this.state.loading,
        [`metric` + upperFirst(metricAxis)]: false,
      },
    });
  }

  fetchTimeInformation(filter: MetricFilter): void {
    this.setState({
      loading: {
        ...this.state.loading,
        time: true,
      },
    });
  }
  fetchTimeInformationError(error: Error): void {}
  fetchTimeInformationSuccess({
    meeting,
    review,
  }: {
    meeting: MetricResponse;
    review: MetricResponse;
  }): void {
    this.setState({
      time: {
        meeting: meeting.data,
        review: review.data,
      },
      loading: {
        ...this.state.loading,
        time: false,
      },
    });
  }
}

export default alt.createStore(NineBoxMetricStore);
